import { SlideHeader, Headline, Body, StatRow } from "../shared";

export function Slide07Traction() {
  const STATS = [
    { value: "$40K", label: "in sales, all word of mouth", color: "#00e5ff" },
    { value: "$0", label: "spent on marketing to date", color: "#ff2d78" },
    { value: "3,000", label: "units manufactured, approx.", color: "#e6c068" },
    { value: "4", label: "issued U.S. patents", color: "#00e5ff" },
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-traction">
      <SlideHeader n="07" label="Traction" />
      <Headline>
        The product exists. <span className="text-accent">People have already bought it.</span>
      </Headline>
      <Body>
        We have never spent a dollar acquiring a customer. The dispenser is sold online as Safe
        Band Pro. This round funds the first real test of paid demand.
      </Body>
      <StatRow testid="pitch-traction-stats" stats={STATS} />
      <span className="inline-block font-mono text-[11px] tracking-[0.15em] uppercase text-white border border-accent bg-accent/10 rounded-full px-4 py-2 mt-5">
        Featured on Shark Tank
      </span>
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-4">
        Company-reported figures, subject to verification.
      </p>
    </div>
  );
}
